<div class="form-container">
    <h2>Creación de Acta de Finalizacion</h2>

    <!-- Contratista -->
    <div *ngIf="currentStep === 1" class="step">
        <form>
            <div class="section">
                <h3 class="section-title">Contratista</h3>
                <div class="form-row">
                    <div class="form-group">
                        <label for="contractorName">Nombre del Contratante</label>
                        <input id="contractorName" type="text" [(ngModel)]="contractor.name"
                            [ngModelOptions]="{standalone: true}" placeholder="Nombre Completo" />
                    </div>
                    <div class="form-group">
                        <label for="contractorTypeId">Tipo de Identificacion</label>
                        <select id="contractorTypeId" [(ngModel)]="contractor.idType"
                            [ngModelOptions]="{standalone: true}">
                            <option value="CC">Cédula de ciudadanía</option>
                            <option value="CE">Cédula de extranjería</option>
                            <option value="PA">Pasaporte</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="contractorId">Número de Identificación</label>
                        <input id="contractorId" type="number" [(ngModel)]="contractor.id"
                            [ngModelOptions]="{standalone: true}" placeholder="123456789" />
                    </div>
                </div>
            </div>
            <div class="section">
                <h3 class="section-title">Contrato</h3>
                <div class="form-row">
                    <div class="form-group">
                        <label for="contractNumber">Número de Contrato</label>
                        <input id="contractNumber" type="number" [(ngModel)]="contract.contractNumber"
                            [ngModelOptions]="{standalone: true}" placeholder="123456789" />
                    </div>
                    <div class="form-group">
                        <label for="contractDuration">Duración del Contrato</label>
                        <input id="contractDuration" type="text" [(ngModel)]="contract.contractDuration"
                            [ngModelOptions]="{standalone: true}" placeholder="1 Año" />
                    </div>
                    <div class="form-group">
                        <label for="contractTerm">Plazo de Ejecusion</label>
                        <input id="contractTerm" type="text" [(ngModel)]="contract.contractTerm"
                            [ngModelOptions]="{standalone: true}" placeholder="1 Año" />
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group">
                        <label for="contractObject">Descripción de Objeto</label>
                        <textarea id="contractObject" rows="4" [(ngModel)]="contract.contractObject"
                            [ngModelOptions]="{standalone: true}"
                            placeholder="Describe el objeto del contrato"></textarea>
                    </div>
                </div>
            </div>
            <div class="section">
                <h3 class="section-title">Terminacion</h3>
                <div class="form-row">
                    <div class="form-group">
                        <label for="contractClause">Clausula de Terminacion</label>
                        <input id="contractClause" type="text" [(ngModel)]="contract.contractClause"
                            [ngModelOptions]="{standalone: true}" placeholder="Clausula de entrega" />
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group">
                        <label for="contractReason">Motivo de Terminacion</label>
                        <textarea id="contractReason" rows="4" [(ngModel)]="contract.contractReason"
                            [ngModelOptions]="{standalone: true}"
                            placeholder="Describe el motivo de la terminacion"></textarea>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group">
                        <label for="contractObservation">Observaciones de Terminacion</label>
                        <textarea id="contractObservation" rows="4" [(ngModel)]="contract.contractObservation"
                            [ngModelOptions]="{standalone: true}" placeholder="Observaciones adicionales"></textarea>
                    </div>
                </div>
            </div>
            <div class="section">
                <h3 class="section-title">Liquidacion</h3>
                <div class="form-row">
                    <div class="form-group">
                        <label for="liquidationsValue">Valor Total del Contrato</label>
                        <input id="liquidationsValue" type="number" [(ngModel)]="liquidations.liquidationsValue"
                            [ngModelOptions]="{standalone: true}" placeholder="0000000" />
                    </div>
                    <div class="form-group">
                        <label for="liquidationsValueWords">Valor en Letras</label>
                        <input id="liquidationsValueWords" type="text" [(ngModel)]="liquidations.liquidationsValueWords"
                            [ngModelOptions]="{standalone: true}" placeholder="Un millon de pesos" />
                    </div>
                </div>
            </div>
            <div class="section">
                <h3 class="section-title">Firma</h3>
                <div class="form-row">
                    <div class="form-group">
                        <label for="signaturePlace">Lugar de Firma</label>
                        <input id="signaturePlace" type="text" [(ngModel)]="signature.signaturePlace"
                            [ngModelOptions]="{standalone: true}" placeholder="Boyaca" />
                    </div>
                    <div class="form-group">
                        <label for="signatureDate">Fecha de Firma</label>
                        <input id="signatureDate" type="date" [(ngModel)]="signature.signatureDate"
                            [ngModelOptions]="{standalone: true}" />
                    </div>
                </div>
            </div>

            <!-- Botón siguiente -->
            <div class="form-actions">
                <button type="button" class="next" (click)="saveAsDraft()">Guardar Formulario</button>
                <button type="button" class="next" (click)="generateDocument()">Generar Terminacion</button>
            </div>
        </form>
    </div>